/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerlijn_Hardlopen2Inputs */

const nl_enums_leerlijn_hardlopen2 = /** @type {(inputs: Enums_Leerlijn_Hardlopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardlopen`)
};

/**

* @param {Enums_Leerlijn_Hardlopen2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerlijn_hardlopen2 = /** @type {((inputs?: Enums_Leerlijn_Hardlopen2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerlijn_Hardlopen2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerlijn_hardlopen2(inputs)
});
export { enums_leerlijn_hardlopen2 as "enums.Leerlijn.Hardlopen" }